import { SymbolType } from '../../domain/game/enum/SymbolType'
import { Container, Text } from '@pixi/react'
import { formatToCommaWithLang, Image, preciseMultiply } from '@slot-nx/core'
import { payoutAmountStyle, symbolCountStyle } from './textStyle'
const leftOddsMap = new Map<SymbolType, Map<string, string>>([
  [SymbolType.M1, new Map([
    ['12', '3'],
    ['10', '1.5'],
    ['8', '0.6'],
  ])],
  [SymbolType.M4, new Map([
    ['12', '1.2'],
    ['10', '0.7'],
    ['8', '0.35'],
  ])],

  [SymbolType.K, new Map([
    ['12', '0.7'],
    ['10', '0.4'],
    ['8', '0.2'],
  ])],
])

const rightOddsMap = new Map<SymbolType, Map<string, string>>([
  [SymbolType.M2, new Map([
    ['12', '2'],
    ['10', '1'],
    ['8', '0.5'],
  ])],
  [SymbolType.M5, new Map([
    ['12', '1'],
    ['10', '0.6'],
    ['8', '0.3'],
  ])],
  [SymbolType.Q, new Map([
    ['12', '0.5'],
    ['10', '0.3'],
    ['8', '0.15'],
  ])],
])
const centerOddsMap = new Map<SymbolType, Map<string, string>>([
  [SymbolType.M3, new Map([
    ['12', '1.5'],
    ['10', '0.8'],
    ['8', '0.4'],
  ])],
  [SymbolType.A, new Map([
    ['12', '0.8'],
    ['10', '0.5'],
    ['8', '0.25'],
  ])],
  [SymbolType.J, new Map([
    ['12', '0.4'],
    ['10', '0.2'],
    ['8', '0.1'],
  ])],
])

const oddsMapTitle = ['12-30', '10-11', '8-9']

export function SymbolOdds(direction: 'left' | 'right' | 'center', stake: number) {
  let map = direction === 'left' ? leftOddsMap : rightOddsMap
  if (direction === 'center') {
    map = centerOddsMap
  }
  return (
    <>
      {Array.from(map).map(([symbolType, oddsMap], index) => {
        return (
          <Container key={`${symbolType}_image`} x={0} y={index * 450} name="symbolOdds">
            <Image
              key={SymbolType[symbolType]}
              name={SymbolType[symbolType]}
              image={SymbolType[symbolType]}
              x={0}
              y={0}
              anchor={[0.5, 0]}
              width={200}
              height={200}
            />
            <Container key={`${symbolType}_map`} x={0} y={250} name={SymbolType[symbolType]}>
              {Array.from(oddsMap).map(([key, value], index) => {
                return (
                  <Container key={index}>
                    <Text
                      key={`${key}_odds`}
                      text={formatToCommaWithLang(preciseMultiply(Number(value), stake))}
                      x={0}
                      anchor={[0.5, 0]}
                      y={index * 55}
                      style={payoutAmountStyle}
                    />
                  </Container>
                )
              })}
            </Container>
          </Container>
        )
      })}
    </>
  )
}
export function SymbolOddsTitle() {
  const map = [1, 2, 3]
  return (
    <>
      {Array.from(map).map((value, index) => {
        return (
          <Container key={`${value}_image`} y={(index) * 450 + 250} name="symbolOdds">
            <Container key={`${value}_map`} name={SymbolType[value]}>
              {Array.from(oddsMapTitle).map((oddsTiltleValue, index) => {
                return (
                  <Container key={index}>
                    <Text
                      key={`${index}_odds`}
                      text={oddsTiltleValue}
                      anchor={[0.5, 0]}
                      y={index * 55}
                      style={symbolCountStyle}
                    />
                  </Container>
                )
              })}
            </Container>
          </Container>
        )
      })}
    </>
  )
}
